<template>
  <div>
    <v-form>
      <v-container>
        <span class="headline">Create Pump Types & Pumps From Excell Data</span>
        <v-row >
          <v-col v-if="true" cols="12" lg="2" md="3" sm="4">
            <v-select v-model="idpump_type" :items="pumpTypes" label="Type 60 Hz. icin seciniz"></v-select>
          </v-col>
 </v-row>
  <v-row >
          <v-col cols="12" md="9">
            <v-textarea
              v-model="type_data"
              label="Pump Type and Pumps Datas"
              hint="Excell tablosunu kopyalayıp yapıştırınız."
            ></v-textarea>
          </v-col>

          <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.material" label="Material" required></v-text-field>
          </v-col>-->
        </v-row>

        <div class="my-2">
          <v-col cols="12" md="6">
            <v-btn class="ma-2" @click="parseData" color="primary">Save</v-btn>

            <v-btn class="ma-2" @click="goBack" color="secondary">Cancel</v-btn>

          </v-col>
           
        </div>
      </v-container>
    </v-form>
  </div>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "PumpTypeAddFromExcell",
  data: () => ({
    token: "",
    type_data: "",
    frequency: "",
    idpump_type: "",
    pumpType: { 
      idpump_type: -1,
      type: "XSP 20",
      frequency: "50",
      outlet_connection_diameter: 100,
      max_sand_quantity : 200,
      pump_outside_diameter : 300,
      number_of_vane : 3,
      degree_of_protection : "IP 68",
      voltage : "100-200",
      rotation : "Clock Wise",
      max_water_temp : "30",
      case : "Stainless Steel",
      diffuser : "Stainless Steel",
      impeller :  "Stainless Steel",
      pump_shaft  : "Stainless Steel",
      coupling :  "Stainless Steel",
      strainer :  "Stainless Steel",
      valve_cap : "Stainless Steel",
      connection : "Based on NEMA Standarts"
     
    } , 
    pumpTypes: []
  }),
  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchPumpTypes()
  },
  methods: {
    goBack : function() {
      window.history.go(-1)
    },
    fetchPumpTypes: function() {
      this.pumpTypes = [];
      this.$http.get(this.$API_URL + "pump_types").then(result => {
        result.data.forEach(pumpType => {
          this.pumpTypes.push({
            text: pumpType.type,
            value: pumpType.idpump_type
          });
        });
      });
    },
    savePumpTypesData: function() {
 
      console.log(this.pumpTypes)
       
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "save_pump_type_from_excell?frequency="+this.frequency
        +"&idpump_type="+this.idpump_type,
        data: this.pumpTypes
      })
        .then(response => {
          console.log(response.data);
          if (response.data == "1"){
           this.pumpTypes = ""
           this.pumpType.idpump_type = -1
           if (response.data == "1")
             window.history.go(-1)
          } 
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    parseData: function() {
      // clear datas.
      this.pumpType.type = []
      this.pumpType.phase = []
      this.pumpType.voltage = []
      this.pumpType.fi_d_max = []
      this.pumpType.frequency = []

      function filterWithStartString(str){
        return str.startsWith("XSP") || str.startsWith("XDP") || str.startsWith("XP")
      }

      this.frequency = this.type_data.substring(0,200).replace(/\t/g, "").split(" ")[0]

      var dataLines = this.type_data
        .replace(/\t\t/g, "\t")
        .replace(/,/g, ".")
        .split("\n");

      dataLines = dataLines.filter(filterWithStartString)

      console.log(dataLines)

      this.pumpTypes = []

      dataLines.forEach(line => {
        this.pumpTypes.push(line.split('\t'))
      })

      console.log(this.pumpTypes)
      // console.log(dataLines[5].split('\t'));
 
      this.savePumpTypesData();
      // console.log(this.perf.hm);
    }
  }
};
</script>
